import React from 'react'
import { Chip, Paper, Stack, Typography } from '@mui/material'
import { amber, blueGrey, grey, purple, red } from '@mui/material/colors'
import * as api from 'common/api'
import { useGlobalState } from 'state'
import { HashMap } from 'common/types'

export const JmaAlertStatus = () => {
  const state = useGlobalState()
  const [statuses, setStatuses] = React.useState<{text: string, color: string}[]>([])

  React.useEffect(() => {
    fetchMessages()
  }, [state.app.baseDate])

  const fetchMessages = async (): Promise<void> => {
    const res = await api.get('/alert/status', {
      point: 'JPGA',
      city: '2210001,2210002',
      date: state.app.getFormattedBaseDate()
    })
    if (res === null) {
      setStatuses([])
      return
    }
    const targets: string[] = []
    res.forEach((row: HashMap) => {
      row.cities.forEach((city: HashMap) => {
        city.alerts.forEach((alert: string) => {
          if (targets.includes(alert) === false) {
            targets.push(alert)
          }
        })
      })
    })
    setStatuses(targets.map((text) => ({
      text,
      color: getStatusColor(text)
    })))
  }

  const getStatusColor = (alert: string) => {
    if (alert.includes('特別警報')) {
      return grey[900]
    } else if (alert.includes('危険警報')) {
      return purple[600]
    } else if (alert.includes('警報')) {
      return red[600]
    } else if (alert.includes('注意報')) {
      return amber[700]
    } else {
      return grey[600]
    }
  }

  return (
    <Stack px={1}>
      <Paper sx={{p: 1, bgcolor: blueGrey[900], borderColor: grey[600]}} variant='outlined'>
        <Typography
          variant='body2'
          sx={{ color: grey[300], fontSize: 12 }}
          textAlign={'center'}
          mb={statuses.length > 0 ? 1 : 0}
        >
          { statuses.length > 0 ? '発表中の警報・注意報' : '発表中の警報・注意報はありません' }
        </Typography>
        <Stack sx={{backgroundColor: 'transparent'}} direction='row' flexWrap='wrap'>
          { statuses.map((status, index) => {
            return <Chip
              key={index}
              label={status.text}
              size='small'
              sx={{
                color: grey[50],
                backgroundColor: status.color,
                mr: 0.5,
                mb: 0.5
              }}
            />
          }) }
        </Stack>
      </Paper>
    </Stack>
  )
}
